



































































































































































































































































































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';
import { calculoIdadeGestacional, ocorrenciasPartoString } from '../../utils/functions';
import {
  egbAbrev, egbStrings, localPartoLowerValues, tipoPartoStrings,
} from '../../utils/constants';

import {
  Egb, InternacaoConfirmarAltaFormData, TipoInformacaoParto, TipoParto,
} from '../../../../back/src/types';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { InformacaoParto } from '../../../../back/src/entity/InformacaoParto';
import { Internacao } from '../../../../back/src/entity/Internacao';

import Confirmar from '../Confirmar.vue';
import CustomDialog from '../CustomDialog.vue';
import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import ThePacientesResumo from '../pacientes/ThePacientesResumo.vue';
import ThePacientesObservacoesAlert from '../pacientes/ThePacientesObservacoesAlert.vue';
import InformacoesPartosTabela from '../informacoes_partos/InformacoesPartosTabela.vue';
import { Parto } from '../../../../back/src/entity/Parto';

export default Vue.extend({
  name: 'TheInternacoesTabelaAtivas',
  components: {
    Confirmar,
    CustomDialog,
    IfEmptyTextPrintNA,
    ThePacientesResumo,
    ThePacientesObservacoesAlert,
    InformacoesPartosTabela,
  },
  props: {
    internacoes: {
      type: Array as () => Internacao[],
      required: true,
    },
  },
  data: () => ({
    loading: {
      confirmarAlta: false,
    },
    tab: 0,
    tiposSanguineos: {},
    alergias: {},
    dialogResumoPaciente: false,
    dialogInformacoesParto: false,
    internacaoSelecionada: null,
  }),
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    temInternacoesAtivas() {
      return !_.isEmpty(this.internacoesAgrupadas);
    },
    internacoesAgrupadas() {
      const internacoesAgrupadas = {};
      const internacoesHospitais = _.groupBy(
        _.orderBy(
          _.filter(
            this.internacoes as Internacao[],
            item => item.datetime_internacao && !item.data_previsao_alta,
          ),
          ['local'],
        ),
        (internacao) => {
          const local = _.toUpper(
            _.get(localPartoLowerValues, _.toLower(_.get(internacao, 'local', '')).trim(), ''),
          );
          if (!local) return 'OUTROS';
          return local;
        },
      );
      const outros = _.get(internacoesHospitais, 'OUTROS', null);
      if (outros) {
        _.unset(internacoesHospitais, 'OUTROS');
      }
      _.assign(internacoesAgrupadas, internacoesHospitais);
      if (outros) {
        _.assign(internacoesAgrupadas, { OUTROS: outros });
      }
      const internacoesPrevisaoAlta = _.filter(
        this.internacoes as Internacao[],
        item => item.datetime_internacao && item.data_previsao_alta,
      );
      if (internacoesPrevisaoAlta.length > 0) {
        _.assign(internacoesAgrupadas, { '-previsaoalta-': internacoesPrevisaoAlta });
      }
      return internacoesAgrupadas;
    },
  },
  async mounted() {
    _.forEach(this.internacoes as Internacao[], (internacao) => {
      this.$set(this.tiposSanguineos, internacao.paciente_id, undefined);
      this.getTipoSanguineo(internacao.paciente_id);
    });
    _.forEach(this.internacoes as Internacao[], (internacao) => {
      this.$set(this.alergias, internacao.paciente_id, undefined);
      this.getAlergias(internacao.paciente_id);
    });
  },
  methods: {
    dataParto(gestacao: Gestacao) {
      if (!gestacao) return null;
      return gestacao.parto ? gestacao.parto.data_parto : null;
    },
    classTrHeader(index: string) {
      switch (index) {
        case '-previsaoalta-':
          return 'trHead--red';
        case 'CASA DE PARTO':
          return 'trHead--teal';
        case 'DOMICÍLIO':
          return 'trHead--indigo';
        case 'SÃO LUIZ':
          return 'trHead--blue';
        case 'SEPACO':
          return 'trHead--cyan';
        default:
          return 'trHead--blue-grey';
      }
    },
    classTrBody(index: string) {
      switch (index) {
        case '-previsaoalta-':
          return 'trBody trBody--red';
        case 'CASA DE PARTO':
          return 'trBody trBody--teal';
        case 'DOMICÍLIO':
          return 'trBody trBody--indigo';
        case 'SÃO LUIZ':
          return 'trBody trBody--blue';
        case 'SEPACO':
          return 'trBody trBody--cyan';
        default:
          return 'trBody trBody--blue-grey';
      }
    },
    selecionaInternacao(internacao: Internacao) {
      this.internacaoSelecionada = internacao;
      this.dialogResumoPaciente = true;
    },
    abreInformacoesParto(internacao: Internacao) {
      this.internacaoSelecionada = internacao;
      this.dialogInformacoesParto = true;
    },
    disabledConfirmaAlta(dataPrevisaoAlta: Date) {
      const diff = moment(moment().format('YYYY-MM-DD')).utc().diff(
        moment(dataPrevisaoAlta).utc(), 'd',
      );
      return diff < 0;
    },
    tipoPartoString(gestacao: Gestacao) {
      if (!gestacao || !gestacao.parto) return null;
      return _.get(tipoPartoStrings, gestacao.parto.tipo_parto, null);
    },
    egbAbrev(egb: Egb) {
      return _.get(egbAbrev, egb, null);
    },
    egbStrings(egb: Egb) {
      return _.get(egbStrings, egb, null);
    },
    idadeGestacional(gestacao: Gestacao) {
      if (!gestacao) return '';
      return calculoIdadeGestacional(gestacao);
    },
    laceracaoSutura(gestacao: Gestacao) {
      if (!gestacao || !gestacao.parto) return '';
      const laceracao = gestacao.parto.laceracao === 0 ? 0 : gestacao.parto.laceracao || -1;
      if (laceracao > 0) {
        return `${laceracao}° ${gestacao.parto.sutura ? 'C' : 'S'}S`;
      } if (laceracao === 0) {
        return 'PI';
      }
      return '';
    },
    ocorrenciasParto(gestacao: Gestacao) {
      if (!gestacao || !gestacao.parto) return null;
      return ocorrenciasPartoString(gestacao.parto);
    },
    ultimaEvolucao(informacoesParto: InformacaoParto[]) {
      return _.maxBy(
        _.filter(
          informacoesParto,
          item => (item.tipo === TipoInformacaoParto.EVOLUCAO && !item.datetime_cancelamento),
        ),
        informacaoParto => informacaoParto.datetime_informacao,
      );
    },
    ultimaEvolucaoData(informacoesParto: InformacaoParto[]) {
      return _.get(this.ultimaEvolucao(informacoesParto), 'datetime_informacao', null);
    },
    ultimaEvolucaoResponsavel(informacoesParto: InformacaoParto[]) {
      return _.get(this.ultimaEvolucao(informacoesParto), 'responsavel.nome', null);
    },
    ultimaEvolucaoObservacoes(informacoesParto: InformacaoParto[]) {
      return _.get(this.ultimaEvolucao(informacoesParto), 'observacoes', null);
    },
    ultimaVisita(informacoesParto: InformacaoParto[]) {
      return _.maxBy(
        _.filter(
          informacoesParto,
          item => (item.tipo === TipoInformacaoParto.VISITA && !item.datetime_cancelamento),
        ),
        informacaoParto => informacaoParto.datetime_informacao,
      );
    },
    ultimaVisitaData(informacoesParto: InformacaoParto[]) {
      return _.get(this.ultimaVisita(informacoesParto), 'datetime_informacao', null);
    },
    ultimaVisitaResponsavel(informacoesParto: InformacaoParto[]) {
      return _.get(this.ultimaVisita(informacoesParto), 'responsavel.nome', null);
    },
    ultimaVisitaObservacoes(informacoesParto: InformacaoParto[]) {
      return _.get(this.ultimaVisita(informacoesParto), 'observacoes', null);
    },
    async getTipoSanguineo(pacienteId) {
      try {
        const response = await Requester.paciente.tipoSanguineo(pacienteId);
        if (response.errors.length > 0) {
          this.$set(this.tiposSanguineos, pacienteId, null);
        } else {
          this.$set(this.tiposSanguineos, pacienteId, response.data);
        }
      } catch (err) {
        this.$set(this.tiposSanguineos, pacienteId, null);
        this.$root.$emit('requestError', err);
      }
    },
    async getAlergias(pacienteId) {
      try {
        const response = await Requester.paciente.historicoResposta(pacienteId, 1);
        if (response.errors.length > 0) {
          this.$set(this.alergias, pacienteId, null);
        } else {
          const alergias = response.data;
          if (alergias && alergias.historico_pergunta && alergias.resposta) {
            const resposta = _.get(alergias.historico_pergunta.opcoes, alergias.resposta, null);
            const { observacoes } = alergias;
            if (observacoes) {
              this.$set(this.alergias, pacienteId, `${resposta} (${observacoes})`);
            } else {
              this.$set(this.alergias, pacienteId, resposta);
            }
          }
        }
      } catch (err) {
        this.$set(this.alergias, pacienteId, null);
        this.$root.$emit('requestError', err);
      }
    },
    // eslint-disable-next-line func-names
    confirmarAltaDebounce: _.debounce(async function () { await this.confirmarAlta(); }, 200),
    async confirmarAlta() {
      if (await this.confirmar.open(
        'Confirmar alta',
        'Tem certeza que deseja confirmar a alta desta paciente?',
      ) === false) {
        return;
      }
      const formData: InternacaoConfirmarAltaFormData = {
        id: this.internacaoSelecionada.id,
      };
      this.loading.confirmarAlta = true;
      try {
        const response = await Requester.internacao.confirmarAltaInternacao(
          this.internacaoSelecionada.id, formData,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Alta confirmada com sucesso.' });
          this.dialogResumoPaciente = false;
          this.pacienteSelecionada = null;
          this.$emit('alta-confirmada', (this.internacaoSelecionada));
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.confirmarAlta = false;
      }
    },
  },
});
